// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// element ui
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "bootstrap/dist/css/bootstrap.min.css"
import loading from '@/loading/loading.js'

// 引用fullpage 插件
import 'fullpage.js/vendors/scrolloverflow'
import VueFullpage from 'vue-fullpage.js'

// bootstrap
import { BootstrapVue } from 'bootstrap-vue'

Vue.use(loading)
Vue.use(BootstrapVue)
Vue.use(VueFullpage)
Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js